import React from "react"
import "./index.css"

const TESTIMONIALS = [
  {
    quote:
      "...what a great job you did on the Shorty Tank Car. We love the detail, and the quality of the car. The new tanker will now be servicing towns along the Great Western Island Railroad. Looking forward to buying more rolling stock from Creative Train Company.",
    author: "Wayne and Barbara, Great Western Island Railroad",
  },
  {
    quote:
      "Most awesome and rare car modeled in any scale of railroading for fans of these cars!",
    author: "Eddie Toombs",
  },
]

export const Testimonials = ({ testimonials = TESTIMONIALS }) => {
  return (
    <div className="testimonials">
      <h2>
        Don&apos;t take our word for it, read what others are saying about us
      </h2>
      <div className="testimonials__container">
        {testimonials.map((testimonial, i) => (
          <div key={`testimonial-${i}`} className="testimonials__testimonial">
            <blockquote>
              <p>{testimonial.quote}</p>
            </blockquote>
            <cite>– {testimonial.author}</cite>
          </div>
        ))}
      </div>
    </div>
  )
}
